import { LockOutlined, MailFilled }                                from '@ant-design/icons';
import { Form, Input, Button }                                     from 'antd';
import React, { useEffect, useState }                              from 'react';
import "./login.scss";
import { useNavigate }                                             from 'react-router-dom';
import { ReactComponent as Apple }                                 from '../../../assets/social/apple.svg';
import { ReactComponent as Facebook }                              from '../../../assets/social/facebook.svg';
import { ReactComponent as Google }                                from '../../../assets/social/google.svg';
import Notification                                                                  from '../../../reuseableComponents/Notification';
import {
  loginApi,
  signupApi,
  forgetPasswordFunction,
  sendOtpApi,
  resetPasswordApi,
  verifyOtpApi,
  newPasswordApi
} from '../apis/apis';
import LoginImage                                                                    from "../assets/loginImage.png";


const Login = () => {
  const [state, setState] = useState({
    formTable: []
  });
  const [form] = Form.useForm();
  let currentRoute = window.location.pathname;
  let navigation = useNavigate()

  let loginData = {
    heading: "Login to continue",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's",
    fields: [
      {
        label: "Email",
        value: "identifier",
        logo: MailFilled
      },
      {
        label: "Password",
        value: "password",
        logo: LockOutlined
      },
    ]
  };

  let signUpData = {
    heading: "Signup",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's",
    fields: [
      // { label: "First name", value: "firstName", logo: UserOutlined },
      // { label: "Last name", value: "lastName", logo: UserOutlined },
      { label: "Email", value: "identifier", logo: MailFilled },
      { label: "Password", value: "password", logo: LockOutlined },
      // { label: "Confirm Password", value: "confirmPassword", logo: LockOutlined },
    ]
  };

  let resetPassword = {
    heading: "Reset Password",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's",
    fields: [
      { label: "OTP", value: "otp", logo: LockOutlined },
      { label: "New password", value: "password", logo: LockOutlined }
    ]
  };

  let newPassword = {
    heading: "New Password",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's",
    fields: [
      { label: "Old Password", value: "oldPassword", logo: LockOutlined },
      { label: "New password", value: "newPassword", logo: LockOutlined },
      { label: "Confirm new password", value: "confNewPassword", logo: LockOutlined },
    ]
  };

  let verifyOtp = {
    heading: "Verify OTP",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's",
    fields: [
      { label: "Enter OTP here", value: "otp", logo: LockOutlined }
    ]
  };

  const loginApiFunction = async (values) => {
    try {
      let result = await loginApi(values)
      if (result?.status && !!result?.data?.data?.user) {
        Notification('success', "Login Successfully", "");
        localStorage.setItem("token", result?.data?.data?.token)
        localStorage.setItem("userLogin", true);
        localStorage.setItem("user", values.identifier)
        localStorage.setItem("userId", result?.data?.data?.user?.id)
        localStorage.setItem("loginUserData", JSON.stringify(result?.data?.data?.user))
        await navigation("/")
      } else if(result?.status && !result?.data?.data?.user) {
        localStorage.setItem("token", result?.data?.data?.token)
        localStorage.setItem("userLogin", true);
        localStorage.setItem("user", values.identifier)
        localStorage.setItem("userId", result?.data?.data?.user?.id)
        navigation("/verify-otp")
      }
      else {
        Notification('error', "Error", "Error while login.");
      }
    }
    catch (err) {
      Notification('error', "Error", err?.response?.data?.data?.message);
    }
  }

  const signupFunction = async (values) => {
    try {
      let result = await signupApi(values)
      if (result?.status) {
        Notification('success', "Register Successfully", result?.data?.data?.message);
        localStorage.setItem("token", result?.data?.data?.token)
        await navigation("/verify-otp")
      }
      else {
        Notification('error', "Error", "Error while registration.");
      }
    }
    catch (err) {
      Notification('error', "Error", !!err?.response?.data.data?.error?.errors[0]?.message ? err?.response?.data.data?.error?.errors[0]?.message : "Error");
    }
  }

  const onFinish = (values) => {
    console.log(34567811111, values)
    if (currentRoute === "/login") {
      loginApiFunction(values)
    }
    else if (currentRoute === "/signup") {
      signupFunction(values)
    }
    else if(currentRoute === "/resetPassword") {
      resetPasswordFunction(values)
    }
    else if(currentRoute === "/verify-otp") {
      verifyOtpFunction(values)
    } else if(currentRoute === "/newPassword") {
      newPasswordFunction(values)
    }
  };
  const forgotPassword = async () => {
    try {
      let formValues = form.getFieldsValue()
      let result = await forgetPasswordFunction({ identifier: formValues?.identifier })
      if (result?.status) {

        Notification('success', "Success", "OTP has been sent to" + result?.data?.data?.message);
        localStorage.setItem("token", result?.data?.data?.token)
        await navigation("/resetPassword")
      }
      else {
        Notification('error', "Error", "Error.");
      }
    }
    catch (err) {
      Notification('error', "Error", "Error.");
    }
  };

  const resetPasswordFunction = async (values) => {
    try {
      let result = await resetPasswordApi(values)
      if (result?.status) {
        Notification('success', "Password has been changed", "");
        await navigation("/login")
      }
      else {
        Notification('error', "Error", "Error.");
      }
    }
    catch (err) {
      Notification('error', "Error", "Error.");
    }
  };

  const sendOtpAgain = async () => {
    try {
      let result = await sendOtpApi({
        identifier:localStorage.getItem("user")
      })
      if (result?.status) {
        Notification('success', "Check OTP again", "");
      }
      else {
        Notification('error', "Error", "Error.");
      }
    }
    catch (err) {
      Notification('error', "Error", "Error.");
    }
  };

  const verifyOtpFunction = async (values) => {
    try {
      let result = await verifyOtpApi(values)
      if(result.status) {
        Notification('success', "Login Successfully", "");
        localStorage.setItem("token", result?.data?.data?.token)
        navigation("/")
      } else {
        Notification('error', "Error", "Error");
      }
    }
    catch (err) {
      Notification('error', "Error", err?.response?.data?.data?.message);
    }
  }

  const newPasswordFunction = async (values) => {
    delete values["confNewPassword"]
    try {
      let result = await newPasswordApi(values)
      if (result?.status) {
        Notification('success', "Successfully Updated","");
      }
      else {
        Notification('error', "Error", "Error.");
      }
    }
    catch (err) {
      Notification('error', "Error", "Error.");
    }
  };

  useEffect(() => {
    if (currentRoute === "/login") {
      setState({ ...state, formTable: loginData });
    }
    else if (currentRoute === "/signup") {
      setState({ ...state, formTable: signUpData });
    }
    else if (currentRoute === "/resetPassword") {
      setState({ ...state, formTable: resetPassword });
    }
    else if (currentRoute === "/newPassword") {
      setState({ ...state, formTable: newPassword });
    }
    else if (currentRoute === "/verify-otp") {
      setState({ ...state, formTable: verifyOtp })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentRoute]);

  return (
    <div className="auth-main-container">
      <div className="left-container">
        <div className="image-container">
          <div className="left-content">
            <h1 onClick={()=>navigation("/")} style={ {
              color: "white",
              cursor:"pointer"
            } }>Rentary</h1>
            <p style={ {
              color: "white"
            } }>Let’s continue with us!</p>
            <div className="description">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. It has been the industry's
              standard dummy text ever since the 1500s.
            </div>
          </div>
          <img src={ LoginImage } alt="Login"/>
        </div>
      </div>

      <div className="right-container">
        <div className="right-content">
          <div className={ "content" }>
            <p className={ "heading" }>{ state.formTable?.heading }</p>
            <p className={ "description" }>{ state.formTable?.description }</p>

            <Form layout="vertical" form={ form }
                  onFinish={ onFinish }
                  style={ {
                    marginTop: 20
                  } }>
              { state.formTable?.fields && state.formTable?.fields.map((item, index) => (
                <Form.Item key={ index } label={ item.label } name={ item.value } style={ {
                  marginBottom: state.formTable.heading === "Login to continue" && 6
                } }>
                  { (item.value === "password" ||
                    item.value === "confirmPassword" ||
                    item.value === "currPassword" ||
                    item.value === "newPassword" ||
                    item.value === "confNewPassword") ? (
                    <Input.Password
                      prefix={ item.logo ? <item.logo style={ { color: "grey" } }/> : null }
                      size="large"
                      placeholder="Enter here"
                    />
                  ) : (
                    <Input
                      prefix={ item.logo ? <item.logo style={ { color: "grey" } }/> : null }
                      size="large"
                      placeholder="Enter here"
                    />
                  ) }
                </Form.Item>
              )) }

              {
                state.formTable.heading === "Login to continue" &&
                <p className="forg-pass-text" onClick={ () => forgotPassword() }>Forgot Password</p>
              }

              {
                currentRoute === "/verify-otp" &&
                <Button onClick={ () => sendOtpAgain() } size="large" type="text" style={ { width: "100%" } }>
                  Send OTP again
                </Button>
              }

              <Form.Item className={ "button" }>
                <Button size="large" type="primary" style={ { width: "100%" } } htmlType="submit">
                  Submit
                </Button>
              </Form.Item>


              {/*{*/}
              {/*  (currentRoute === "/login" || currentRoute === "/signup") &&*/}
              {/*  <div className={ "socialContent" }>*/}
              {/*    <p>Or Sign in with</p>*/}
              {/*    <div>*/}
              {/*      <Facebook height={ 32 } width={ 32 }/>*/}
              {/*      <Google height={ 32 } width={ 32 }/>*/}
              {/*      <Apple height={ 32 } width={ 32 }/>*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*}*/}

            </Form>
          </div>
        </div>
        {
          currentRoute === "/login" ?
            <h4 className={ "bottom-nav" }>Not a member? <span onClick={ () => navigation("/signup") }>Sign up</span>
            </h4> :
            currentRoute === "/signup" &&
            <h4 className={ "bottom-nav" }>Already a member? <span onClick={ () => navigation("/login") }>Sign in</span>
            </h4>
        }
      </div>
    </div>
  );
};

export default Login;
